module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-regular.b8ee546a.woff";